import { useState } from 'react';
import { get, post } from '../../infra/rest';
import { PlanAddonTypes } from '../../modules/renew-plan/v1/typings';
import useNotifications from './use-notifications';
import { openPopup } from '../utils/popup';
import { getPaymentPageUrl } from '../requests/get-payment-page-url';

interface UseAddonPurchaseResult {
  loading: boolean;
  purchaseAddon: (addonId?: PlanAddonTypes) => Promise<void>;
}

export const useAddonPurchase = (): UseAddonPurchaseResult => {
  const [loading, setLoading] = useState(false);

  const { addNotification } = useNotifications();

  const purchaseAddon = async (addonId?: PlanAddonTypes): Promise<void> => {
    setLoading(true);

    try {
      const response = await getPaymentPageUrl(addonId);
      setLoading(false);
      if (response && response.paymentPageUrl) {
        openPopup(response.paymentPageUrl);
      } else {
        throw new Error('Invalid payment URL received');
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err instanceof Error ? err.message : 'Failed to get payment URL';
      addNotification({
        message: errorMessage,
        type: 'error',
      });
    }
  };

  return { loading, purchaseAddon };
};

export default useAddonPurchase;
